var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_profile-2user",
    "data-name": "vuesax/outline/profile-2user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.037,23.332h-.18a1.222,1.222,0,0,0-.405,0,11.577,11.577,0,1,1,.653,0Zm-.36-19.957a8.294,8.294,0,0,0-.315,16.583,3.745,3.745,0,0,1,.72,0,8.3,8.3,0,0,0-.4-16.583Z",
    transform: "translate(8.572 2.812)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.169,19.125a.623.623,0,0,1-.2-.023A1.782,1.782,0,0,1,.009,17.618,1.64,1.64,0,0,1,1.4,15.75c.27-.023.562-.023.81-.023A6.192,6.192,0,0,0,1.877,3.352,1.666,1.666,0,0,1,.189,1.688,1.7,1.7,0,0,1,1.877,0a9.583,9.583,0,0,1,9.562,9.563,9.542,9.542,0,0,1-9.2,9.563Z",
    transform: "translate(35.045 7.312)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M17.033,22.753a22.225,22.225,0,0,1-12.2-3.375C1.71,17.308,0,14.473,0,11.391s1.71-5.94,4.838-8.032c6.75-4.477,17.685-4.477,24.39,0,3.105,2.07,4.837,4.9,4.837,7.987s-1.71,5.94-4.837,8.032A22.279,22.279,0,0,1,17.033,22.753ZM6.7,6.193c-2.16,1.44-3.33,3.285-3.33,5.22,0,1.913,1.193,3.757,3.33,5.175,5.6,3.757,15.052,3.757,20.655,0,2.16-1.44,3.33-3.285,3.33-5.22,0-1.912-1.192-3.758-3.33-5.175C21.757,2.458,12.308,2.458,6.7,6.193Z",
    transform: "translate(3.599 27.984)",
    fill: "#d00c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H54V54H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.675,16.893a1.661,1.661,0,0,1-1.642-1.35,1.711,1.711,0,0,1,1.3-2A9.113,9.113,0,0,0,5.073,11.9a4.4,4.4,0,0,0,1.98-3.465A4.364,4.364,0,0,0,5.1,4.99a9.421,9.421,0,0,0-3.69-1.643A1.695,1.695,0,1,1,2.148.04a12.557,12.557,0,0,1,5,2.25,7.738,7.738,0,0,1,3.285,6.142A7.836,7.836,0,0,1,7.12,14.6a12.186,12.186,0,0,1-5.085,2.25A1.053,1.053,0,0,1,1.675,16.893Z",
    transform: "translate(39.589 29.795)",
    fill: "#d00c1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fc75962c970b9046a96c3b77a0909120.svg";
export { ForwardRef as ReactComponent };